import { useEffect, useRef, type FC } from "react";
import { useGlobalModalOpen } from "../../context/GlobalModal";
import type { V2PrivacyControls } from "../../privacy";
import { usePrivateModeRecoveryModal } from "./PrivateModeToggleV2";
import "../../scss/private_mode_access.scss";

/** Mount once outside account-data Suspense so live unlock controls survive. */
export const PrivateModeSessionExpiry: FC<{
  controls: V2PrivacyControls;
  available?: boolean;
}> = ({ controls, available = true }) => {
  const modalOpen = useGlobalModalOpen();
  const openUnlock = usePrivateModeRecoveryModal(controls);
  const offered = useRef(false);

  useEffect(() => {
    if (!controls.sessionExpired) {
      offered.current = false;
      return;
    }
    if (
      offered.current ||
      modalOpen ||
      !available ||
      controls.recoveryExportRequired ||
      !["locked", "error"].includes(controls.status)
    )
      return;

    const shown = openUnlock("login", false, {
      onlyIfClosed: true,
      loginVariant: "session-expired",
    });
    if (shown) {
      offered.current = true;
      // Consume only the notification. Session locking is owned by the host;
      // neither showing nor dismissing this dialog requests a wallet signature.
      controls.dismissSessionExpired?.();
    }
  }, [available, controls, modalOpen, openUnlock]);

  return null;
};
